export default "<div #gmapedit [ngStyle]=\"{ height: gHeight+'px' }\">\n\n</div>\n"